export default {
  PRAGATI_HOME_URL: "pragati_home_url",
  PRAGATI_POST_CALL_END_POINT_URL: "pragati_post_call_end_point_url",
  AUTH_TOKEN: "authToken",
  AGENT_ID: "agent_id",
  AGENT_CODE: "agent_code",
  AGENT_NAME: "agent_name",
  LOGIN_CODE: "login_code",
  VENDOR: "vendor",
  SOURCE_FROM: "source_from",
  LOGIN_AGENT_CODE: "login_agent_code",
  FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM: "first_time_optimization_page_load_param",
  START_APPLICATION_END_POINT_URL: "start_application_end_point_url",
  ULIP_TRAINING: "ulip_training",
  LANDING_FROM_QMS: "landing_from_qms",
  SHOW_NEW_OPTIMIZATION: "show_new_optimization",
  SET_AGENT_ID_SESSION_STORAGE:"session_agent_id",
  SHOW_PRODUCT_DROPDOWN:"show_product_dropdown",
  SUB_CHANNEL_CODE: "sub_channel_code",
  IS_PASA_PRODUCT: "is_pasa_product",
  SHOW_PASA: "show_pasa",
  IS_POSP: "is_posp",
  MAX_UPSELL_VALUE: "max_upsell_value"
};
